// extracted by mini-css-extract-plugin
export default {"header":"RequirementFormHeader_header__ku15S","header_fixedHeight":"RequirementFormHeader_header_fixedHeight__9tS7V","bin":"RequirementFormHeader_bin__xuffj"};